/**
 * Resolves logo URL for img src. Billing logos are stored as bucket-relative keys;
 * location event logos from the API may be full signed S3 URLs.
 */
export function resolveLogoSrc(
  logoUrl: string | null | undefined,
  logoBucketUrl: string
): string | null {
  if (logoUrl == null || logoUrl === '') {
    return null;
  }
  const trimmed = logoUrl.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  if (!logoBucketUrl) {
    return trimmed;
  }
  return `${logoBucketUrl}${trimmed}`;
}
